import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, HostBinding, Input, Output, TemplateRef, numberAttribute } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogBodyDirective, DialogFooterDirective, DialogHeaderMetaDirective } from '../../directives';

@Component({
    selector: 'app-si-dialog',
    templateUrl: './si-dialog.component.html',
    styleUrls: ['./si-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SiDialogComponent {
    @Input() header: string = 'Title';
    @Input({ transform: numberAttribute }) headerLevel: 1 | 2 | 3 | 4 | 5 | 6 = 2;
    @Input() subheader: string;
    @Input() hideHeader: boolean = false;
    @HostBinding('class.si-dialog--no-header') get isNoHeader(): boolean { return this.hideHeader; }
    @Input() hideCloseButton: boolean = false;
    @Input() hideSaveButton: boolean = false;
    @Input() cancelButtonText: string = 'Cancel';
    @Input() saveButtonText: string = 'Save';
    @Input() saveButtonDisabled: boolean = false;
    @Input() saveButtonClass: string | string[] | Set<string> | Record<string, boolean> | null = null;
    @Input() modalBodyClasses: string;
    @Input() modalFooterClasses: string;
    @Input() isLoading: boolean;
    @Input() preventClose: boolean = false;
    @Output() close: EventEmitter<void> = new EventEmitter<void>();
    @Output() save: EventEmitter<void> = new EventEmitter<void>();

    @ContentChild(DialogBodyDirective, { read: TemplateRef }) dialogBodyTemplate: TemplateRef<DialogBodyDirective>;
    @ContentChild(DialogFooterDirective, { read: TemplateRef }) dialogFooterTemplate: TemplateRef<DialogFooterDirective>;
    @ContentChild(DialogHeaderMetaDirective, { read: TemplateRef }) dialogHeaderMetaTemplate: TemplateRef<DialogHeaderMetaDirective>;

    constructor(
        private readonly matDialogRef: MatDialogRef<SiDialogComponent>,
    ) {
    }

    onClose(response?: any): void {
        this.close.emit();

        if (!this.preventClose) {
            this.onCloseDialog(response);
        }
    }

    onCloseDialog(response?: any): void {
        this.matDialogRef.close(response);
    }

    onSave(): void {
        this.save.emit();
    }
}
